module.exports = __webpack_public_path__ + "img/36.37c9a613.png";